import http from "../utils/http-common";

const generateLink = (data: any) => {
  return http.post("/generate_download_link", data);
};

const download = (token: any) => {
  return http.get(`/download/${token}`, {
    responseType: "blob",
  });
};

const downloadService = {
  generateLink,
  download,
};

export default downloadService;
